import { Body, BulletedList, BulletedListItem } from '@alto/design-system';
// eslint-disable-next-line @alto/no-pocky-import
import { Button, FlexRow, spacing } from '@alto/pocky';
import React, { PureComponent } from 'react';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  display: inline;
`;

const StyledFlexRow = styled(FlexRow)<{ inline?: boolean; spacing?: string }>`
  ${({ inline, spacing }) =>
    inline &&
    `
    flex-direction: row-reverse;
    align-items: flex-end;
    > *:not(:last-child) {
      margin-bottom: 0;
      margin-left: ${spacing};
    }
  `}
`;

type DefaultProps = {
  readonly onSkip: () => void;
};

type Props = DefaultProps & {
  readonly onAddInsurance: () => void;
  readonly onSelectCashPay: () => void;
  readonly inlineButton?: boolean;
};

export default class EmptyInsurance extends PureComponent<Props> {
  static defaultProps = {
    onSkip: undefined,
  };

  render() {
    const { inlineButton, onAddInsurance, onSelectCashPay, onSkip } = this.props;
    return (
      <FlexRow spacing={spacing.lgSpacing}>
        <Body>
          <Body fontFamily="bold">Be sure to tell us about all of your benefits.&nbsp;</Body>
          <Body>The more you list, the easier it is to get the best pricing for you.</Body>
        </Body>
        <FlexRow spacing={spacing.xsSpacing}>
          <Body>Benefits include:</Body>
          <BulletedList>
            <BulletedListItem>Your primary insurance card</BulletedListItem>
            <BulletedListItem>Your secondary insurance card</BulletedListItem>
            <BulletedListItem>Savings card (Team Cuban Card, etc)</BulletedListItem>
          </BulletedList>
        </FlexRow>
        <StyledFlexRow
          spacing={spacing.xsSpacing}
          inline={inlineButton}
        >
          <StyledButton onClick={onAddInsurance}>Add benefits</StyledButton>
          <StyledButton
            onClick={onSelectCashPay}
            kind="secondary"
          >
            I don’t have any benefits
          </StyledButton>
          {onSkip ? (
            <StyledButton
              onClick={onSkip}
              kind="tertiary"
            >
              I’ll do this later
            </StyledButton>
          ) : null}
        </StyledFlexRow>
      </FlexRow>
    );
  }
}
